// This file was auto-generated by Fern from our API Definition.
export const TriggerDiscoveryConnectionState = {
    Ready: "ready",
    NeedsAuth: "needs_auth",
    NeedsInput: "needs_input",
};
